// Module
var code = `<div class="signature-pad-container"> <div class="border-2 border-gray-300 rounded-xs"> <canvas></canvas> </div> <div class="mt-2"> <button ng-click="\$ctrl.clear()" class="btn-flat cancel border border-gray-300" type="button" translate>common.signature.CLEAR</button> </div> </div>`;
// Exports
export default code;